import { render, staticRenderFns } from "./RecipientSenderSelector.vue?vue&type=template&id=6f194b4e&scoped=true"
import script from "./RecipientSenderSelector.vue?vue&type=script&lang=js"
export * from "./RecipientSenderSelector.vue?vue&type=script&lang=js"
import style0 from "./RecipientSenderSelector.vue?vue&type=style&index=0&id=6f194b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f194b4e",
  null
  
)

export default component.exports